import { appArticleList } from "@/entities";
import { NewsCardBase } from "@/entities/dev/news/ui/NewsCardBase";
import { useQuery } from "@tanstack/react-query";
import Link from "next/link";
import Image from "next/image";
import React, { useEffect, useRef } from "react";

export const NewsSlider = () => {
  const slug = "media";
  const state = "active";
  const common_category_id = "";
  const keyword = "";
  const page = 1;
  const perPage = 6;
  const filterParams = { state, common_category_id, keyword };

  const { error, isLoading, data } = useQuery({
    queryKey: [`app-articles`, { ...filterParams, slug, page, perPage }],
    queryFn: () => appArticleList({ ...filterParams, slug, page, perPage }),
  });

  if (error) return <></>;
  if (isLoading) return <></>;

  return (
    <div>
      <div className="xl:max-w-[1280px] mx-auto w-full px-5 xl:px-0 flex justify-between items-center mb-6 md:mb-20">
        <p
          className="md:text-4xl md:leading-14 tracking-tight text-xl leading-8 text-black-almostBlack"
          style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
        >
          언론보도
        </p>
        <Link
          href={"/app/media"}
          className="md:text-2xl md:leading-9 text-base leading-7 tracking-tight underline text-black-200"
          style={{ fontFamily: '"pre-Regular", sans-serif' }}
        >
          전체보기
        </Link>
      </div>

      <div className="md:w-full md:max-w-7xl md:mx-auto px-5 xl:px-0">
        {data?.count && data?.count > 0 ? (
          <ul className="border-t md:border-t-[1.8px] border-midGray-30">
            {data?.result.map((item: any, index: number) => (
              <li
                key={index}
                className="border-b md:border-b-[1.8px] border-midGray-30 px-2 md:px-5 py-5 md:py-10"
              >
                <Link
                  href={`/app/media/${item.id}`}
                  className="flex items-center"
                >
                  {/* 날짜 */}
                  <div
                    className="md:text-lg md:leading-8 text-[15px] leading-5 tracking-tight text-lightGray-30 w-24 md:w-36 "
                    style={{ fontFamily: '"pre-Regular", sans-serif' }}
                  >
                    {new Date(item.created_at).toLocaleDateString("ko")}
                  </div>
                  {/* 타이틀 */}
                  <p
                    className="flex-1 md:text-2xl md:leading-10  text-base leading-6 tracking-tight  text-black-almostBlack truncate"
                    style={{ fontFamily: '"pre-Medium", sans-serif' }}
                  >
                    {item.title}
                  </p>
                  {/* 아이콘 */}
                  <div className="w-4 h-4 ml-5 mt-0 md:w-7 md:h-7 relative ">
                    <Image
                      src="/assets/images/icon/arrow-up-right.svg"
                      alt="LinkIcon"
                      fill
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <p
            className="my-30 text-center tracking-tight text-lightGray-10"
            style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
          >
            등록된 데이터가 없습니다.
          </p>
        )}
      </div>
    </div>
  );
};
